import { render, staticRenderFns } from "./LiveEvents-Single.vue?vue&type=template&id=3e24f36e&scoped=true"
import script from "./LiveEvents-Single.js?vue&type=script&lang=js&external"
export * from "./LiveEvents-Single.js?vue&type=script&lang=js&external"
import style0 from "./LiveEvents-Single.vue?vue&type=style&index=0&id=3e24f36e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e24f36e",
  null
  
)

export default component.exports